<template>
  <div class="cart-item">
    <button class="cart-item__close" @click="onDelete">
      <svg width="20px" height="20px">
        <use xlink:href="@/assets/icons/sprite.svg#close"></use>
      </svg>
    </button>
    <div class="cart-item__left">
      <picture class="cart-item__img" v-if="data.images.length != 0">
        <source :srcset="'https://akshop.a-dev.xyz' + data.images[0]" />
        <img :src="'https://akshop.a-dev.xyz' + data.images[0]" :alt="data.name" loading="eager" />
      </picture>
      <picture class="cart-item__img" v-else>
        <source srcset="@/assets/image/empty.webp" />
        <img src="@/assets/image/empty.jpg" alt="Нет фото" loading="eager" />
      </picture>
    </div>
    <div class="cart-item__right">
      <div class="cart-item__title">{{ data.name }}</div>
      <div class="cart-item__case">
        <div class="cart-item__prices">
          <div class="cart-item__price-new">
            {{ priceFormat(data.basePrice) }}
          </div>
        </div>
        <div class="animation-btn">
          <ChangeBasket :source="data" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { priceFormat } from "@/helpers/priceFormat";
  import ChangeBasket from "./ChangeBasket.vue";
  import { onMounted, PropType, ref } from "vue";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  const props = defineProps({
    data: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  });

  const emit = defineEmits(["onClear"]);

  const basket = ref<Array<IProduct>>([] as Array<IProduct>);

  onMounted(() => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  });

  const onDelete = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");

    basket.value = basket.value.filter((basketItem: IProduct) => {
      if (basketItem.id == props.data.id) {
        eventBus.emit("delete-card", props.data);
      }

      return basketItem.id != props.data.id;
    });

    if (basket.value.length == 0) {
      emit("onClear");
    }

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };
</script>
<style lang="scss">
  .cart-item {
    display: flex;
    position: relative;
    justify-content: space-between;
    gap: 12px;
    .change-basket {
      margin-left: inherit;
      width: 138px;
    }

    &__close {
      cursor: pointer;
      display: flex;
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
    }

    &__case {
      position: relative;
      display: flex;
      align-items: center;
    }

    &__img {
      img {
        width: 73px;
        height: 73px;
      }
    }

    &__title {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;

      margin-right: 30px;
      margin-bottom: 12px;
      color: $almostBlack;
      font-size: 12px;
      line-height: 16px;
    }

    &__price {
      &-new {
        white-space: nowrap;
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
        color: $darkGreen;
      }
    }

    &__left {
      flex: 0 0 auto;
    }

    &__right {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
</style>
